import { h, Component } from 'preact';
import TicketAreaButton from 'components/bolt/ticketAreaButton/ticketAreaButton';
import DeviceDetector from 'device-detector-js';
import { getShowtimesData } from 'utils/bolt/index';
import { addToAppleWallet, addToGoogleWallet, getManageTicketsUrl } from 'helpers/tickets';
import HTML from 'components/core/html/html';
import s from 'components/bolt/mobileWalletButton/mobileWalletButton.sss';

export default class MobileWalletButton extends Component {

	checkChrome() {
		if (typeof window !== 'undefined') {
			const deviceDetector = new DeviceDetector();
			const userAgent = window.navigator.userAgent;
			const device = deviceDetector.parse(userAgent);
			return device.client.name === 'Chrome Mobile' || device.client.name === 'Chrome';
		}
		return false;
	}

	checkGoogleApp() {
		if (typeof window !== 'undefined') {
			const userAgent = window.navigator.userAgent;
			return userAgent.includes('GSA');
		}
		return false;
	}

	render({ appData, client }) {
		const copy = appData?.copy?.baseCopy || {};
		const isIOS = client.isIOS;
		const isSafari = client.isSafari;
		const isAndroid = client.device !== 'desktop' && !isIOS;
		const studioRoot = appData?.urls?.roots?.studio || '';
		const appleWalletLogo = studioRoot + '/images/appleWalletLogo.svg';
		const appleWalletText = studioRoot + '/images/appleWalletText.svg';
		const googleWalletLogo = studioRoot + '/images/googleWalletLogo.svg';
		const googleWalletText = studioRoot + '/images/googleWalletText.svg';
		const appleWalletEnabled = getShowtimesData()?.mobileWallet?.apple;
		const googleWalletEnabled = getShowtimesData()?.mobileWallet?.google;
		const isChrome = this.checkChrome();
		const isGoogleApp = this.checkGoogleApp();
		const manageTicketsUrl = getManageTicketsUrl();
		const iosUnsupportedMessage = copy.$IOS_UNSUPPORTED_MESSAGE.replace(
			'<link>', 
			`<a href="${manageTicketsUrl}" target="_blank">${copy.$COPY_THIS_LINK}</a>`
		);
		const androidUnsupportedMessage = copy.$ANDROID_UNSUPPORTED_MESSAGE.replace(
			'<link>',
			`<a href="${manageTicketsUrl}" target="_blank">${copy.$COPY_THIS_LINK}</a>`
		);

		let content;

		if (appleWalletEnabled) {
			if (isIOS && isSafari && !isGoogleApp) {
				content = (
					<TicketAreaButton onClick={addToAppleWallet} isIOsSafari>
						<img class ={s.walletLogoText} src={appleWalletText} alt="Apple Wallet Text" />
						<img class={s.walletLogo} src={appleWalletLogo} alt="Apple Wallet Logo" />
					</TicketAreaButton>
				);
			} else if (isIOS && (!isSafari || isGoogleApp)) {
				content = (
					<span class={s.unsupportedMessage}>
						<HTML content={iosUnsupportedMessage} markdown />
					</span>
				);
			}
		}

		if (googleWalletEnabled) {
			if (isAndroid && (isChrome || isGoogleApp)) {
				content = (
					<TicketAreaButton onClick={addToGoogleWallet} isAndroidChrome>
						<img class ={s.walletLogoText} src={googleWalletText} alt="Google Wallet Text" />
						<img class={s.walletLogo} src={googleWalletLogo} alt="Google Wallet Logo" />
					</TicketAreaButton>
				);
			} else if (isAndroid && !isChrome) {
				content = (
					<span class={s.unsupportedMessage}>
						<HTML content={androidUnsupportedMessage} markdown />
					</span>
				);
			}
		}
		return content;
	}
}

